import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthClassicNewPassword() {
	return <AuthShell variant="classic"><AuthForm variant="classic" mode="new-password" /></AuthShell>;
}

export default AuthClassicNewPassword;
